import React, { useContext } from 'react';
// Import des icônes
import agileIcon from '../assets/icon/skills/agile.png';
import dockerIcon from '../assets/icon/skills/docker.png';
import gitIcon from '../assets/icon/skills/git.png';
import giteaIcon from '../assets/icon/skills/gitea.png';
import linuxIcon from '../assets/icon/skills/linux.png';
import meriseIcon from '../assets/icon/skills/merise.png';
import mongoIcon from '../assets/icon/skills/mongo.png';
import mysqlIcon from '../assets/icon/skills/mysql.png';
import nodejsIcon from '../assets/icon/skills/nodejs.png';
import phpIcon from '../assets/icon/skills/php.png';
import reactIcon from '../assets/icon/skills/react.png';
import symfonyIcon from '../assets/icon/skills/symfony.png';
import windowsIcon from '../assets/icon/skills/windows.png';
import githubIcon from '../assets/icon/skills/github.png';
import githubActionsIcon from '../assets/icon/skills/github.png';
import kanbanIcon from '../assets/icon/skills/kanban.png';
import awsIcon from '../assets/icon/skills/aws.png';
import grafanaIcon from '../assets/icon/skills/grafana.png';
import cloudflareIcon from '../assets/icon/skills/cloudflare.png';
import ga4Icon from '../assets/icon/skills/ga4.png';
import gscIcon from '../assets/icon/skills/gsc.webp';
import { LanguageContext } from '../context/LanguageContext';

const SkillCard = ({ title, skills }) => (
  <div className="bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-shadow duration-300 h-full flex flex-col">
    <h3 className="text-xl font-bold text-indigo-800 mb-4">{title}</h3>
    <div className="grid grid-cols-2 sm:grid-cols-3 gap-6 flex-grow">
      {skills.map((skill) => (
        <div key={skill.name} className="flex flex-col items-center gap-2 group">
          <div className="w-16 h-16 flex items-center justify-center p-2 rounded-lg bg-indigo-50 group-hover:bg-indigo-100 transition-colors duration-300">
            <img 
              src={skill.icon} 
              alt={skill.name} 
              className="w-12 h-12 object-contain"
            />
          </div>
          <span className="text-sm font-medium text-indigo-600">{skill.name}</span>
        </div>
      ))}
    </div>
  </div>
);

const Competences = () => {
  const { t } = useContext(LanguageContext);

  const skillCategories = [
    {
      title: t('frameworks'),
      skills: [
        { name: "React", icon: reactIcon },
        { name: "Node.js", icon: nodejsIcon },
        { name: "Symfony", icon: symfonyIcon },
      ]
    },
    {
      title: t('devops'),
      skills: [
        { name: "Docker", icon: dockerIcon },
        { name: "GitHub Actions", icon: githubActionsIcon },
        { name: "AWS", icon: awsIcon },
      ]
    },
    {
      title: t('versionControl'),
      skills: [
        { name: "Git", icon: gitIcon },
        { name: "GitHub", icon: githubIcon },
        { name: "Gitea", icon: giteaIcon },
      ]
    },
    {
      title: t('os'),
      skills: [
        { name: "Linux", icon: linuxIcon },
        { name: "Windows", icon: windowsIcon },
      ]
    },
    {
      title: t('databases'),
      skills: [
        { name: "MySQL", icon: mysqlIcon },
        { name: "MongoDB", icon: mongoIcon },
        { name: "phpMyAdmin", icon: phpIcon },
      ]
    },
    {
      title: t('methods'),
      skills: [
        { name: "Agile", icon: agileIcon },
        { name: "Merise", icon: meriseIcon },
        { name: "Kanban", icon: kanbanIcon },
      ]
    },
  ];

  return (
    <div className="min-h-screen bg-gray-50 pt-36 pb-20">
      <div className="max-w-6xl mx-auto px-4">
        {/* Introduction */}
        <div className="text-center mb-16">
          <h1 className="text-4xl font-bold text-indigo-900 mb-6">
            {t('skillsTitle')}
          </h1>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            {t('skillsIntro')}
          </p>
        </div>

        {/* Grille de compétences */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-stretch">
          {skillCategories.map((category) => (
            <SkillCard 
              key={category.title}
              title={t(category.title)}
              skills={category.skills}
            />
          ))}
        </div>

        {/* Cartes supplémentaires en bas : Monitoring & Performance et SEO */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-8 items-stretch">
          <SkillCard
            title={t('Monitoring & Performance')}
            skills={[
              { name: 'Grafana', icon: grafanaIcon },
              { name: 'Cloudflare', icon: cloudflareIcon },
            ]}
          />

          <SkillCard
            title={t('SEO Analytics')}
            skills={[
              { name: 'GA4', icon: ga4Icon },
              { name: 'GSC', icon: gscIcon },
            ]}
          />

        </div>
      </div>
    </div>
  );
};

export default Competences; 